import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../ExerciseHub/exerciseHub.css";
import "./reportAccess.css";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ReportAccess() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    let active = true;
    setState("loading");
    fetch(`${API_URL}/api/report/${token}`)
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then((body) => {
        if (!active) return;
        setData(body);
        setState("ready");
      })
      .catch(() => active && setState("missing"));
    return () => { active = false; };
  }, [token]);

  if (state === "loading") return <main className="exercise-shell" data-testid="report-access-loading">Loading your report…</main>;
  if (state === "missing") {
    return (
      <main className="exercise-shell" data-testid="report-access-not-found">
        <h1>This report link is invalid or has expired</h1>
        <p>Please contact us if you believe this is a mistake.</p>
        <Link to="/" data-testid="report-access-home-link">Return home</Link>
      </main>
    );
  }

  const report = data.report || {};
  return (
    <main className="exercise-shell" data-testid="report-access-page">
      <header className="exercise-header" data-testid="report-access-header">
        <Link to="/" data-testid="report-access-logo-link"><img src="/brand/exercise-hub-logo.png" alt="InterAct Globally" /></Link>
        <span>Your Performance Audit</span>
      </header>
      <section className="exercise-intro">
        <p className="exercise-eyebrow">{data.recipientFirstName ? `Hi ${data.recipientFirstName},` : "Your report"}</p>
        <h1 data-testid="report-access-subject">{report.emailSubject || "Your InterAct Performance Audit"}</h1>
      </section>
      <section className="report-access-sections" data-testid="report-access-sections">
        {(report.sections || []).map((section) => (
          <article key={section.sectionId} className="report-access-section" data-testid={`report-access-section-${section.sectionId}`}>
            <h2>{section.heading}</h2>
            <p>{section.body}</p>
          </article>
        ))}
      </section>
      {data.interstitial && (
        <p className="report-access-interstitial" data-testid="report-access-interstitial">
          {data.interstitial.prefixText}
          <Link to={data.interstitial.linkRoute} data-testid="report-access-interstitial-link">{data.interstitial.linkText}</Link>
          {data.interstitial.suffixText}
        </p>
      )}
      <section className="exercise-next-steps" data-testid="report-access-next-steps">
        {data.matchedExerciseUrl && (
          <a href={data.matchedExerciseUrl} data-testid="report-access-exercise-cta">Open your recommended exercise</a>
        )}
        <a href={data.bookingUrl} data-testid="report-access-booking-cta">Book your 1:1 Executive Consultation</a>
      </section>
    </main>
  );
}
